import { orderBy } from 'lodash'

import { Collection } from 'modules/core/lib/mobx-rest'
import createCollectionContext from 'modules/core/store/collections/CollectionContext'

import AttendanceSettingsEvent from 'modules/attendance/store/models/AttendanceSettingsEvent'

class AttendanceSettingsEvents extends Collection<AttendanceSettingsEvent> {
  get cacheKey(): string {
    return 'attendanceSettingsEvents'
  }

  model() {
    return AttendanceSettingsEvent
  }

  get indexes() {
    return ['employees_setting_id']
  }

  bySetting(attendanceSettingId: string): AttendanceSettingsEvent[] {
    return orderBy(
      this.filter({ employees_setting_id: attendanceSettingId }),
      (event: AttendanceSettingsEvent) => event.timestamp,
      'desc'
    )
  }
}

const singleton: AttendanceSettingsEvents = new AttendanceSettingsEvents()

export default singleton

const { provider: SettingsEventsProvider, hook: useSettingsEvents } = createCollectionContext<
  AttendanceSettingsEvent,
  AttendanceSettingsEvents
>()

export { SettingsEventsProvider, useSettingsEvents }
